export default __webpack_public_path__ + "static/media/metabolic-profile.8f294277.svg";